export enum IsHiddenForClientDocumentEnum {
    All = 1,
    No,
    Yes
}
